import { axiosPrivate } from '../api/axios';

const useAxiosPrivate = () => {
  return axiosPrivate;
};

export default useAxiosPrivate;
